/**
 * DiscussionsTab — the full community feed.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { fadeUp, stagger } from '@/lib/motion';
import { useCommunities } from '../context/CommunitiesContext';
import { useModalState } from '../hooks';
import PostCard from '../post/PostCard';
import PostComposer from '../post/PostComposer';
import EmptyState from '../EmptyState';

export default function DiscussionsTab({ community, role }) {
  const { getPosts } = useCommunities();
  const [isComposerOpen, openComposer, closeComposer] = useModalState(false);
  const posts = [...getPosts(community.id)].sort((a, b) => (b.pinned - a.pinned) || (b.createdAt - a.createdAt));

  return (
    <div className="u-container max-w-2xl py-8">
      <button
        type="button" onClick={openComposer}
        className="flex w-full items-center gap-3 rounded-full border border-line bg-card px-4 py-3 text-left text-sm text-subtle shadow-soft transition-colors hover:border-coral/40"
      >
        <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-coral/10 text-coral"><Plus className="h-4 w-4" /></span>
        Start a discussion, ask a question, share a recommendation…
      </button>

      {posts.length === 0 ? (
        <EmptyState type="discussions" onCTAClick={openComposer} />
      ) : (
        <motion.div variants={stagger} initial="hidden" animate="show" className="mt-6 space-y-4">
          {posts.map((post, i) => (
            <motion.div key={post.id} variants={fadeUp} custom={i % 8}>
              <PostCard post={post} communityRole={role} />
            </motion.div>
          ))}
        </motion.div>
      )}

      <PostComposer isOpen={isComposerOpen} onClose={closeComposer} community={community} />
    </div>
  );
}
